import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=3051efc0"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=3051efc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports